<template>
  <div
    class="shopper-product"
    v-if="linkObject.type != 'chat'"
    @click="
      evt => {
        handleClick()
      }
    "
  >
    <div class="shopper-product__sizer"></div>
    <div class="shopper-product__elements">
      <div
        class="shopper-product__product-image"
        :style="{ backgroundImage: `url(${linkObject.image_url})` }"
      ></div>
    </div>
  </div>
  <div
    class="shopper-chatbot-link"
    v-else
    @click="
      evt => {
        handleClick()
      }
    "
  >
    <div class="shopper-chatbot-link__sizer"></div>
    <div class="shopper-chatbot-link__button"></div>
  </div>
</template>

<script>
export default {
  data: () => ({}),

  props: {
    linkObject: Object
  },

  methods: {
    handleClick() {
      window.open(this.linkObject.target_url, "_blank")
    }
  }
}
</script>

<style lang="scss">
.shopper-product {
  cursor: pointer;
  position: relative;
  flex: 0 0 50%;
  height: auto;

  &__sizer {
    padding-bottom: 100%;
    width: 100%;
  }

  &__elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__product-image {
    position: relative;
    width: 90%;
    padding-bottom: 90%;
    margin: 0 auto;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.shopper-chatbot-link {
  cursor: pointer;
  position: relative;
  flex: 0 1 75%;
  height: auto;

  &__sizer {
    padding-bottom: 25%;
    width: 100%;
  }

  &__button {
    position: absolute;
    top: 0;
    left: 2.5%;
    width: 95%;
    height: 100%;
    background-color: #e354db;
    background-image: url("~@/assets/chatbot_cta.svg");
    background-repeat: no-repeat;
    background-size: 90%;
    background-position: center;
  }
}
</style>
